import { z } from 'zod/v4';

export const PatchAdminDocumentTypeBodySchema = z
  .object({
    title: z.string().min(1).max(255).optional(),
    description: z.string().max(255).optional(),
    shortDescription: z.string().max(255).optional(),
    impactAreaId: z.string().max(255).optional(),
  })
  .strict();

export type PatchAdminDocumentTypeBodyType = z.infer<
  typeof PatchAdminDocumentTypeBodySchema
>;
